import { render, staticRenderFns } from "./EntregaMotoControle.vue?vue&type=template&id=7b52220e"
import script from "./EntregaMotoControle.vue?vue&type=script&lang=js"
export * from "./EntregaMotoControle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports